import {
  ChangeDetectionStrategy,
  Component,
  EnvironmentInjector,
  inject,
  Injector,
  OnInit,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import {
  AbstractTableViewsService,
  ConfigService,
  LibraryInjector,
  ngxMatDateFormats,
} from '@tiltgroup/web-components';
import { environment } from '@environments/environment';
import { IconService } from '@services/icon.service';
import { AppVersionGuardService } from '@services/app-version-guard.service';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { TableViewsService } from '@services/queries/services/table-views.service';

/** Hosts both the signed-in app (PrivateLayoutComponent) and the public pages, such as a signing link. */
@Component({
  selector: 'nx-root',
  templateUrl: './app.component.html',
  imports: [RouterOutlet, MatDialogModule, MatSnackBarModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: ngxMatDateFormats },
    { provide: AbstractTableViewsService, useClass: TableViewsService },
  ],
})
export class AppComponent implements OnInit {
  static injector: Injector;
  // Registers the app's SVG icons, which public pages use too.
  private _iconService = inject(IconService);
  private _injector = inject(EnvironmentInjector);
  private _appVersionGuardService = inject(AppVersionGuardService);
  private _configService = inject(ConfigService);

  constructor() {
    AppComponent.injector = this._injector;
    LibraryInjector.setInjector(this._injector);
    this._configService.setUpEnvironment(environment);
  }

  ngOnInit() {
    this._appVersionGuardService.init();
  }
}
